/* global window */

import $ from 'jquery';
import debounce from 'lodash/debounce';

const nonce = window.siteData.nonce;
const currentLanguage = window.siteData.language || 'da';

import './ResumeList.scss';
import template from './ResumeList.vhtml';

export default {
	name: 'ResumeList',
	template: template,
	props: {
		'search': {
			type: String,
			default: '',
		},
		'category': {
			type: String,
			default: '',
		},
	},
	data: () => ({
		resumes: [],
		isLoading: false,
	}),
	watch: {
		search() {
			this.reload();
		},
		category() {
			this.reload();
		},
	},
	methods: {
		reload: debounce(function () {
			this.isLoading = true;
			getItems(this.category, this.search)
				.then(items => {

					if (typeof items != 'object') {
						result = JSON.parse(result)
					}

					if (items) {
						this.resumes = items;
					}
				})
				.always(() => this.isLoading = false);
		}, 500),
	},
	created() {
		this.reload();
	}
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} category
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems(category = '', search = '') {
	const params = {
		'area': category,
		's': search,
		'_wpnonce': nonce,
		'lang': currentLanguage,
		'_': '1.5',
	};

	return $.get(`/wp-json/be/v1/resumes`, params);
}
